import React from 'react';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import moment from 'moment';
import PropTypes from 'prop-types';
import styles from './Perfil.module.css';
import { Button, Avatar, Spin, Modal, Select } from 'antd';
import * as rutes from '../routes';
import { setTitolApartat, errorConsultaServidor } from '../actions';
import { getIdObservadorIntroduccio, getUsuari, getObservadorsAsArray } from '../reducers';
import {
  MISSATGE_MUNICIPI_NO_TROBAT,
  MISSATGE_COMARCA_NO_TROBADA,
  TITOL_PERFIL,
  MISSATGE_SPIN_INFORME_OBSERVADOR,
  MISSATGE_USUARI_NO_ACTIU,
} from '../constantsFormularis';
import {
  fetchResumObservador,
  fetchObtenirDadesUsuariPerIdObservador,
} from '../actions/consultesServidor';
import { NotificacioError } from './Notification';
import ErrorBoundaryWrapper from './commons/ErrorBoundaryWrapper';
import configuracio from '../configuracioEntorns';
import { ANY_INICI_OBSERVACIONS } from '../constantsObservacions';

class Perfil extends React.Component {
  componentDidMount() {
    this.props.setTitolApartat(TITOL_PERFIL);
  }

  constructor(props) {
    super(props);
    this.state = {
      isPeticioEnCurs: false,
      usuariNoActiu: false,
      modalAnyVisible: false,
      anySeleccionat: moment().year(),
    };
  }

  mostrarModal = (valor) => {
    this.setState({ modalAnyVisible: valor });
  };

  peticioEnCurs = (value) => {
    this.setState({ isPeticioEnCurs: value });
  };

  gestioError = (error, tipusError) => {
    if (tipusError === MISSATGE_USUARI_NO_ACTIU) {
      this.setState({ usuariNoActiu: true });
    }
    this.props.errorConsultaServidor(error, tipusError);
  };

  gestioErrorInforme = (error, titolTipus) => {
    this.peticioEnCurs(false);
    if (error && error.message && error.titol) {
      NotificacioError(error.titol, error.message);
    } else this.props.errorConsultaServidor(error, titolTipus);
  };

  gestioExit = (resposta) => {
    this.peticioEnCurs(false);
    if (resposta && resposta.message && resposta.titol) {
      NotificacioError(resposta.titol, resposta.message);
    }
  };


  getAnyActualText = () => {
    return moment().year();
  };

  getObservadorInforme = (observadors, idObservador) => {
    const observador = observadors.find(obs => obs.key === idObservador);
    if (!observador) {
      return null;
    }

    return ({
      nom: observador.nom,
      cognom1: observador.cognom1,
      cognom2: observador.cognom2,
      usuari: observador.usuariNom,
      fotoUrl: observador.foto,
      telefon: observador.telefon,
      correu: observador.usuariCorreuElectronic,
      dataAlta: observador.historic[observador.historic.length - 1].dataAlta,

      adreça: {
        carrer: observador.carrer,
        numero: observador.numero,
        pis: observador.pis,
        porta: observador.porta,
        codiPostal: observador.codiPostal,
        codiINE: observador.codiINE,
        nomMunicipiObservador: observador.municipi,
        nomComarcaObservador: observador.comarca
      }
    })
  };

  generarInforme = () => {
    const { idObservador, observador } = this.props;
    this.mostrarModal(false);
    if (!idObservador || isNaN(idObservador)) {
      return NotificacioError('Avís', 'Dades del Observador no trobades.');
    }

    let observadorInforme = null;
    if (idObservador !== this.props.usuari.idObservador) {
      observadorInforme = this.getObservadorInforme(this.props.observadors, idObservador);
    }
    fetchObtenirDadesUsuariPerIdObservador(this.props.usuari.idObservador).then(
      (dadesUsuari) => {
        if (dadesUsuari.actiu) {
          const primerDiaAnySeleccionat = moment(
            this.state.anySeleccionat.toString() + '-01-01',
          );
          const darrerDiaAnySeleccionat =
            this.state.anySeleccionat === this.getAnyActualText()
              ? moment()
              : moment('' + this.state.anySeleccionat + '-12-31');

          this.peticioEnCurs(true);

          fetchResumObservador(
            primerDiaAnySeleccionat,
            darrerDiaAnySeleccionat,
            idObservador,
            observadorInforme || observador,
          ).then(
            (resultat) => {
              this.gestioExit(resultat);
            },
            (error) => {
              this.gestioErrorInforme(
                error,
                'Error generant informe observador.',
              );
            },
          );
        } else {
          this.gestioError('Avís Error', MISSATGE_USUARI_NO_ACTIU);
        }
      },
      (error) => {
        this.gestioErrorInforme(error, 'Error generant informe observador.');
      },
    );
  };

  render() {
    const { usuariNoActiu, modalAnyVisible } = this.state;
    const titolModal = 'Seleccionar any per generar informe anual';

    if (usuariNoActiu) {
      const urlBase = configuracio.ruta;
      return <Redirect to={`${urlBase}/login`} />;
    }

    const { observador, dadesUsuari } = this.props;
    const nomMunicipiObservador = observador.adreça.nomMunicipiObservador
      ? observador.adreça.nomMunicipiObservador
      : MISSATGE_MUNICIPI_NO_TROBAT;
    const nomComarcaObservador = observador.adreça.nomComarcaObservador
      ? observador.adreça.nomComarcaObservador
      : MISSATGE_COMARCA_NO_TROBADA;
    const nomObservador = `${observador.nom} ${observador.cognom1} ${observador.cognom2}`;
    const dadaNoTrobada = 'Dada no trobada';
    const dataAlta = moment(observador.dataAlta).format('DD-MM-YYYY');

    // Generar anys des de ANY_INICI_OBSERVACIONS fins a l'any actual
    const currentYear = new Date().getFullYear();
    const anys = [];
    for (let y = ANY_INICI_OBSERVACIONS; y <= currentYear; y++) {
      anys.push(y);
    }

    return (
      <Spin
        spinning={this.state.isPeticioEnCurs}
        tip={MISSATGE_SPIN_INFORME_OBSERVADOR}
        delay={300}
      >
        <div>
          <Modal
            visible={modalAnyVisible}
            title={titolModal}
            closable={false}
            className={styles.selectorAnyModal}
            footer={[
              <Button
                key="ok"
                type="primary"
                onClick={() => this.generarInforme()}
              >
                Generar Informe
              </Button>,
              <Button key="cancel" onClick={() => this.mostrarModal(false)}>
                Cancel·lar
              </Button>,
            ]}
          >
            <div style={{ marginBottom: 16 }}>
              <label
                htmlFor="any-select"
                style={{ fontWeight: 'bold', marginRight: 8 }}
              >
                Seleccionar Any
              </label>
              <Select
                id="any-select"
                style={{ minWidth: 120 }}
                defaultValue={currentYear}
                onChange={(valor) => this.setState({ anySeleccionat: valor })}
              >
                {anys.map((any) => (
                  <Select.Option key={any} value={any}>
                    {any}{' '}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </Modal>

          <div className={styles.perfil}>
            <div className={styles.imatgePerfil}>
              <Avatar size={128} src={observador.fotoUrl} alt={nomObservador} />
            </div>
            <div className={styles.nomUsuariSmall}>Nom: </div>
            <span className={styles.nomUsuariSmall}>{observador.nom}</span>
            <div className={styles.nomUsuariSmall}>Primer cognom: </div>
            <span className={styles.nomUsuariSmall}>{observador.cognom1}</span>
            <div className={styles.nomUsuariSmall}>Segon cognom: </div>
            <span className={styles.nomUsuariSmall}>{observador.cognom2}</span>
            <span className={styles.nomUsuariMedium}>
              {observador.nom} {observador.cognom1} {observador.cognom2}
            </span>
            <div>Usuari: </div>
            <span>
              {observador.usuari ? observador.usuari : dadesUsuari.nom}
            </span>
            <div>Correu electrònic: </div>
            <span>
              {observador.correu ? observador.correu : dadesUsuari.correu}
            </span>
            <div>Telèfon: </div>
            <span>{observador.telefon}</span>
            <div>Data d'alta: </div>
            <span>{dataAlta}</span>
            <div>Carrer: </div>
            <span>{observador.adreça.carrer}</span>
            <div>Número: </div>
            <span>{observador.adreça.numero}</span>
            <div>Pis: </div>
            <span>{observador.adreça.pis}</span>
            <div>Porta: </div>
            <span>{observador.adreça.porta}</span>
            <div>Codi Postal: </div>
            <span>{observador.adreça.codiPostal}</span>
            <div>Municipi: </div>
            <span>{nomMunicipiObservador}</span>
            <div>Comarca: </div>
            <span>{nomComarcaObservador}</span>
          </div>
          <div className={styles.canviPwd}>
            <Link
              to={{
                pathname: rutes.rutaCanviContrasenya,
                query: { render: false },
              }}
            >
              <Button
                icon="lock"
                disabled={observador.usuari === dadaNoTrobada}
              >
                Canvi contrasenya
              </Button>
            </Link>
          </div>
          <div className={styles.generarInforme}>
            <Button
              type="primary"
              size="large"
              icon="cloud-download"
              onClick={() => this.mostrarModal(true)}
            >
              Descarregar informe anual (Excel)
            </Button>
          </div>
        </div>
      </Spin>
    );
  }
};

Perfil.propTypes = {
  observador: PropTypes.object,
  dadesUsuari: PropTypes.object,
  setTitolApartat: PropTypes.func.isRequired,
  errorConsultaServidor: PropTypes.func.isRequired,
  usuari: PropTypes.object,
};

const mapStateToProps = (state) => {
  return {
    idObservador: getIdObservadorIntroduccio(state),
    usuari: getUsuari(state),
    observadors: getObservadorsAsArray(state),
  };
};

const mapDispatchToProps = {
  setTitolApartat,
  errorConsultaServidor,
};

export default ErrorBoundaryWrapper(
  connect(mapStateToProps, mapDispatchToProps)(Perfil),
);
